import React from 'react';

const About = () => {
  const features = [
    {
      id: 1,
      title: '100% Handcrafted',
      icon: (
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
      )
    },
    {
      id: 2,
      title: 'Premium Materials',
      icon: (
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
      )
    },
    {
      id: 3,
      title: 'Bespoke Creations',
      icon: (
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
      )
    },
    {
      id: 4,
      title: 'Ethical & Sustainable',
      icon: (
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      )
    },
    {
      id: 5,
      title: 'Worldwide Shipping',
      icon: (
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
      )
    }
  ];

  return (
    <section id="about" className="min-h-screen flex items-center py-8 sm:py-12 md:py-16 bg-gradient-to-br from-gray-50 via-amber-50 to-orange-50 relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-72 h-72 bg-gradient-to-br from-amber-200/20 to-orange-200/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-72 h-72 bg-gradient-to-tr from-amber-200/20 to-orange-200/20 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto px-6 md:px-8 lg:px-12 relative z-10 w-full">
        {/* Centered Header */}
        <div className="text-center mb-12">
          <div className="inline-block px-3 py-1.5 bg-amber-100 rounded-full mb-4">
            <span className="text-amber-700 font-semibold text-xs uppercase tracking-wide">Our Story</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-3">
            Our Story
          </h2>
          <p className="text-lg md:text-xl text-amber-700/90 font-medium" style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}>
            Where Craft Meets Contemporary Design
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-12 items-center">
          {/* Left Content Section - Video and Images */}
          <div className="space-y-3 sm:space-y-4 md:space-y-6">
            {/* Video */}
            <div className="group relative rounded-2xl overflow-hidden shadow-2xl transform hover:scale-[1.02] transition-all duration-500">
              
                <video 
                  src="/images/video1.mp4" 
                  className="w-full h-[200px] sm:h-[250px] md:h-[300px] object-cover"
                  autoPlay
                  loop
                  muted
                  playsInline
                />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </div>

            {/* Images */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 md:gap-6">
              {/* Image 1 */}
              <div className="group relative rounded-2xl overflow-hidden shadow-2xl transform hover:scale-[1.02] transition-all duration-500">
              <img 
                src="/images/wovn2.jpeg" 
                alt="Wovn Rugss handcrafted rug craftsmanship – wovnrugss.com"
                className="w-full h-[250px] sm:h-[300px] md:h-[350px] object-cover"
                onError={(e) => {
                  e.target.src = 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=800&h=1000&fit=crop';
                }}
              />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </div>

              {/* Image 2 */}
              <div className="group relative rounded-2xl overflow-hidden shadow-2xl transform hover:scale-[1.02] transition-all duration-500">
              <img 
                src="/images/wovn1.jpeg" 
                alt="Luxury handcrafted rug by Wovn Rugss – wovnrugss.com"
                className="w-full h-[250px] sm:h-[300px] md:h-[350px] object-cover"
                onError={(e) => {
                  e.target.src = 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=800&h=1000&fit=crop';
                }}
              />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </div>
            </div>
          </div>

          {/* Right Content Section - Features */}
          <div className="space-y-4 sm:space-y-6">
            {/* About Paragraphs */}
            <div className="space-y-3 mb-4 sm:mb-6">
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                Wovn Rugss (wovnrugss.com) blends heritage craftsmanship with contemporary design. We craft woven rugs, wovn rugs, and luxury handcrafted rugs (wovnrugs, wovenrugs, wovenruggs) that elevate modern interiors—each piece reflects our commitment to quality, tradition, and refined aesthetics.
              </p>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                Wovn Rugss (wovnrugss.com) is a manufacturer and supplier of premium handcrafted rugs, specializing in hand-tufted rugs, hand-knotted rugs, and custom-made rugs for residential and commercial spaces. We work closely with skilled artisans to create rugs that combine traditional craftsmanship with modern interior design.
              </p>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                Every rug at Wovn Rugss (wovnrugss.com) is handcrafted using high-quality materials, ensuring durability, comfort, and long-lasting beauty. Our collection includes luxury area rugs, contemporary rugs, modern rugs, and bespoke rugs, designed to enhance living rooms, bedrooms, offices, hotels, and hospitality projects.
              </p>
            </div>

            {/* Features - All in one line */}
            <div>
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 md:mb-6 text-center">
                Custom Rugs Tailored to You
              </h2>
              <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900 mb-3 sm:mb-4 md:mb-6 text-center">
                What Makes Us <span className="bg-gradient-to-r from-amber-600 to-orange-600 bg-clip-text text-transparent">Different</span>
              </h3>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2 sm:gap-3 md:gap-4">
                {features.map((feature) => (
                  <div 
                    key={feature.id} 
                    className="group bg-white rounded-xl p-3 md:p-4 shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 border border-amber-100/50 flex flex-col items-center justify-center h-full"
                  >
                    <div className="w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-amber-500 to-orange-600 rounded-lg flex items-center justify-center mb-2 md:mb-3 shadow-md group-hover:scale-110 transition-transform duration-300">
                      <svg className="w-5 h-5 md:w-6 md:h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        {feature.icon}
                      </svg>
                    </div>
                    <h4 className="text-xs font-bold text-gray-900 group-hover:text-amber-600 transition-colors leading-tight text-center">
                      {feature.title}
                    </h4>
                  </div>
                ))}
              </div>
            </div>

            {/* Quote Section - Centered below features */}
            <div className="flex justify-center mt-4 sm:mt-6">
              <div className="bg-gradient-to-br from-amber-100 via-orange-100 to-amber-200 rounded-2xl p-4 sm:p-6 md:p-7 shadow-xl border border-amber-200/50 max-w-2xl w-full">
                <div className="flex items-start gap-2 sm:gap-3">
                  <svg className="w-6 h-6 sm:w-8 sm:h-8 text-amber-600 flex-shrink-0 mt-1" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.996 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.984zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z"/>
                  </svg>
                  <div>
                    <p className="text-xs sm:text-sm md:text-base text-gray-800 leading-relaxed italic mb-2 sm:mb-3">
                      A rug is more than décor—it's comfort, character, and a statement.
                    </p>
                    <p className="text-sm sm:text-base md:text-lg text-gray-900 font-bold">
                      Where tradition meets luxury.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
